import { ListItem } from './list-item';

export class AddMarket {
  fromMarket: ListItem;
  toMarket: ListItem;
  reversable = true;
  region: ListItem;
}
